import { render, staticRenderFns } from "./coupon-detail.vue?vue&type=template&id=6f23b7c2&scoped=true&"
import script from "./coupon-detail.vue?vue&type=script&lang=js&"
export * from "./coupon-detail.vue?vue&type=script&lang=js&"
import style0 from "./coupon-detail.vue?vue&type=style&index=0&id=6f23b7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23b7c2",
  null
  
)

export default component.exports